import { Application } from 'interfaces';
import { action, computed, makeObservable, observable } from 'mobx';
import { RoutePaths } from '../../helpers/constants/RoutePaths';
import { history } from '../../helpers/History';
import { ApplicationCloseReason } from '../../sdk';
import StoreModel from '../Index';
import { KioskApplication } from './KioskApplication';

export class CommonModel {
    @observable
    public applications: KioskApplication[] = [];

    constructor(public root: StoreModel) {
        makeObservable(this);
    }

    @action
    setApplications(applications: Application[]): KioskApplication[] {
        return (this.applications = applications.map(
            (x: Application) => new KioskApplication(x)
        ));
    }

    openApplication(application: KioskApplication) {
        // Check kiosk status and open app in parallel
        // to speed up opening process
        this.checkKioskStatus();

        history.push({
            pathname: application.path,
            search: history.location.search,
        });
    }

    private checkKioskStatus() {
        this.root.loader.show();

        const promises = [
            this.root.peripheryStatus.check(),
            this.root.kioskReadyStatus.checkBatch(),
        ];

        return Promise.all(promises)
            .then((_) => {
                if (this.root.isOutOfOrder) {
                    const error = {
                        hasperipheryErrors: this.root.peripheryStatus.hasErrors,
                        isKioskReady: this.root.kioskReadyStatus.isKioskReady,
                    };

                    throw error;
                }

                return true;
            })
            .catch((error) => {
                console.error(error);

                return this.root.sdk
                    .closeApp(ApplicationCloseReason.KioskOutOfOrder)
                    .then(() => {
                        history.push({
                            pathname: RoutePaths.KioskOutOfOrder,
                            search: window.location.search,
                        });
                    });
            })
            .finally(() => {
                this.root.loader.hide();
            });
    }

    @computed
    get hasMultiplyApplications() {
        return this.applications.length > 1;
    }
}
